module.exports = __webpack_public_path__ + "static/media/MATIC-WOOFY.b2093b92.png";